import ReactDOM from 'react-dom/client';
import App from '@/App';
import '@/index.css';
import './i18n'; // Initialize i18next for translations
import { initErrorTracking } from '@/lib/errorTracking';

// Before anything renders, so a crash during the first paint is still caught.
// No-op unless VITE_SENTRY_DSN is set. See lib/errorTracking.ts for the
// phone-number scrubbing, which matters because a phone IS the credential here.
initErrorTracking();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <App />
);
